import { connect } from "react-redux";

import { getSearch } from "actions/search";
import Search from "./Search";


const mapState = ({ search }) => ({
    data: search.items,
    count: search.count,
    loading: search.loading
});

export default connect(mapState, {
    getSearch
})(Search);